<template>
  <div class="min-h-screen h-full bg-[#f5f5f7]">
    <div class="grid grid-cols-1 lg:grid-cols-2 h-full">
      <div class="hidden lg:block h-full">
        <div class="w-full h-full flex bg-primary relative"></div>
      </div>
      <div
        class="h-full relative flex items-center justify-center col-span-1 bg-[#f5f5f7]"
      >
        <div
          class="p-4 sm:p-8 lg:p-12 py-6 w-full max-w-xl text-center relative"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import url('./assets/css/main.css');
</style>
